import { ActivityLog } from "@/pages/admin/ActivityLogs";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";

interface ActivityLogDetailsDialogProps {
  log: ActivityLog | null;
  open: boolean;
  onClose: () => void;
}

export const ActivityLogDetailsDialog = ({
  log,
  open,
  onClose,
}: ActivityLogDetailsDialogProps) => {
  if (!log) return null;

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Activity Log Details</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium">Action Type</label>
            <div className="mt-1">
              <Badge>{log.action_type.replace(/_/g, " ")}</Badge>
            </div>
          </div>

          <div>
            <label className="text-sm font-medium">Category</label>
            <div className="mt-1">
              <Badge variant="outline">{log.action_category}</Badge>
            </div>
          </div>

          <div>
            <label className="text-sm font-medium">Description</label>
            <p className="mt-1 text-sm">{log.description}</p>
          </div>

          <div>
            <label className="text-sm font-medium">Timestamp</label>
            <p className="mt-1 text-sm">
              {new Date(log.created_at).toLocaleString()}
            </p>
          </div>

          {log.resource_type && (
            <div>
              <label className="text-sm font-medium">Resource</label>
              <p className="mt-1 text-sm">
                {log.resource_type} (ID: {log.resource_id})
              </p>
            </div>
          )}

          {log.ip_address && (
            <div>
              <label className="text-sm font-medium">IP Address</label>
              <p className="mt-1 text-sm font-mono">{log.ip_address}</p>
            </div>
          )}

          {log.user_agent && (
            <div>
              <label className="text-sm font-medium">User Agent</label>
              <p className="mt-1 text-sm text-muted-foreground break-all">
                {log.user_agent}
              </p>
            </div>
          )}

          {log.metadata && Object.keys(log.metadata).length > 0 && (
            <>
              <Separator />
              <div>
                <label className="text-sm font-medium">Metadata</label>
                <pre className="mt-2 p-4 bg-muted rounded-lg text-xs overflow-x-auto">
                  {JSON.stringify(log.metadata, null, 2)}
                </pre>
              </div>
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
